module.exports = __webpack_public_path__ + "static/media/price.987327c6.png";